import i18n from 'modules/core/lib/i18n'

export function translatedWeekdays(day: string) {
  switch (day) {
    case 'monday':
      return i18n.t('common.monday')
    case 'tuesday':
      return i18n.t('common.tuesday')
    case 'wednesday':
      return i18n.t('common.wednesday')
    case 'thursday':
      return i18n.t('common.thursday')
    case 'friday':
      return i18n.t('common.friday')
    case 'saturday':
      return i18n.t('common.saturday')
    case 'sunday':
      return i18n.t('common.sunday')
    default:
      return day // FIXME: Are we sure we want to return the day here?
  }
}
